import type { RecordedSessionRecord } from '~/powersync/generated/schema';

/**
 * Input for attaching a recorded session to a workout. `id` is **included** —
 * the caller supplies a deterministic `uuidv5(source|externalId)` so re-imports
 * of the same session collide on the primary key (Vikunja #58). Only the
 * server-managed timestamps are omitted; `workoutId` and the denormalized
 * `userId` are supplied by the caller.
 */
export type CreateRecordedSessionInput = Omit<
  RecordedSessionRecord,
  'createdAt' | 'updatedAt' | 'deletedAt'
>;
